import { render, staticRenderFns } from "./project-search-results.vue?vue&type=template&id=10e77432&"
import script from "./project-search-results.vue?vue&type=script&lang=js&"
export * from "./project-search-results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports